<template>
    <v-container>
        <v-row>
            <v-col>
                <span class="d-block headline">Søknad om gave<span v-if="app.name">: {{app.name}}</span></span>
                <span class="d-block body-1">Dette skjema benyttes for søknad om ny gave.</span>

                <v-stepper v-model="sessionStep">
                    <v-stepper-header>
                        <v-stepper-step :color="sessionStep == 1 ? appColors.background: 'success'" step="1" :complete="sessionStep > 1" style="cursor: pointer;">
                            Angi navn og formålskategori(er)
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :color="sessionStep == 2 ? appColors.background: 'success'" step="2" :complete="sessionStep > 2">Velg ett formålsområde</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :color="sessionStep == 3 ? appColors.background: 'success'" step="3" :complete="sessionStep > 3">Angi aldersgruppe prosjektet gjelder for</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :color="sessionStep == 4 ? appColors.background: 'success'" step="4" :complete="sessionStep > 4">Kostnadsbudsjett for prosjektet</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :color="sessionStep == 5 ? appColors.background: 'success'" step="5" :complete="sessionStep > 5">Finansieringsplan</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :color="sessionStep == 6 ? appColors.background: 'success'" step="6" :complete="sessionStep > 6">Kort beskrivelse av prosjektet</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <v-card>
                                <v-card-title>Angi navn og formålskategori (mulig å velg fler)</v-card-title>
                                <v-card-text>
                                    <v-form ref="1">
                                        <v-text-field v-model="app.name" label="Prosjektnavn*" filled clearable :rules="[v => !!v && !!v.trim() || 'Påkrevd']"></v-text-field>
                                        <v-row>
                                            <v-col cols="12" lg="6" v-for="purpose in applicationChoicesPurpose" :key="purpose.name">
                                                <v-card @click="purpose.selected = !purpose.selected" class="ma-2" style="cursor: pointer;">
                                                    <v-card-title>
                                                        <v-row>
                                                            <v-col cols="10">{{purpose.name}}</v-col>
                                                            <v-col cols="2">
                                                                <v-btn top right icon>
                                                                    <v-icon v-if="purpose.selected" color="success" x-large>mdi-check-circle</v-icon>
                                                                    <v-icon v-else x-large>mdi-checkbox-blank-circle-outline</v-icon>
                                                                </v-btn>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-title>
                                                    <v-card-text>
                                                        {{purpose.description}}
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </v-card-text>

                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                            <v-card>
                                <v-card-title>Velg prosjektets formålsområdet</v-card-title>
                                <v-card-text>
                                    <v-form ref="2">
                                        <v-container fluid>
                                            <v-row>
                                                <v-col cols="12" lg="6" v-for="area in applicationChoicesArea" :key="area.name">
                                                    <v-card @click="selectArea(area)" class="ma-2" style="cursor: pointer; white-space: nowrap;">
                                                        <v-card-title>
                                                            <v-row>
                                                                <v-col cols="10">{{area.name}}</v-col>
                                                                <v-col cols="2">
                                                                    <v-btn top right icon>
                                                                        <v-icon v-if="area.selected" color="success" x-large>mdi-check-circle</v-icon>
                                                                        <v-icon v-else x-large>mdi-checkbox-blank-circle-outline</v-icon>
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card-title>
                                                        <v-card-text>
                                                            {{area.description}}

                                                            <!-- <span>{{area.description}}</span>

                                                            <v-btn absolute top right icon>
                                                                <v-icon v-if="area.selected" color="success" x-large>mdi-check-circle</v-icon>
                                                                <v-icon v-else x-large>mdi-checkbox-blank-circle-outline</v-icon>
                                                            </v-btn> -->
                                                        </v-card-text>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-form>
                                </v-card-text>

                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="3">
                            <v-card>
                                <v-card-title>Angi aldersgruppe prosjektet gjelder for</v-card-title>
                                <v-card-text>
                                    <v-form ref="3">
                                        <v-container fluid>
                                            <v-row>
                                                <v-col cols="12" md="6" v-for="ageGroup in applicationChoicesAgeGroup" :key="ageGroup.name">
                                                    <v-card @click="selectAgeGroup(ageGroup)" class="ma-2" style="cursor: pointer;">
                                                        <v-card-title>{{ageGroup.name}}</v-card-title>
                                                        <v-card-text>
                                                            <span>{{ageGroup.description}}</span>

                                                            <v-btn absolute top right icon>
                                                                <v-icon v-if="ageGroup.selected" color="success" x-large>mdi-check-circle</v-icon>
                                                                <v-icon v-else x-large>mdi-checkbox-blank-circle-outline</v-icon>
                                                            </v-btn>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-form>
                                </v-card-text>

                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="4">
                            <v-card>
                                <v-card-title>Kostnadsbudsjett for prosjektet</v-card-title>
                                <v-card-text>
                                    <v-form>
                                        <span class="font-weight-bold">Registrer innkjøp av varer og tjenester til prosjektet</span>
                                        <v-container>
                                            <v-row>
                                                <v-col md="8" cols="12">
                                                    <v-text-field v-model="newProcurementCost.description" @keyup.enter="() => { if(canAddProcurementCost) addProcurementCost(newProcurementCost)}" label="Beskrivelse av vare/tjeneste" filled></v-text-field>
                                                </v-col>
                                                <v-col md="3" cols="12">
                                                    <currency-text-field v-model="newProcurementCost.cost" @keyup.enter="() => { if(canAddProcurementCost) addProcurementCost(newProcurementCost)}" label="Beløp" reverse filled :rules="[rules.inputIsNumber, rules.noDecimalMark, rules.noDecimal]">
                                                        <template v-slot:append>
                                                            <span class="ma-0">kr</span>
                                                        </template>
                                                    </currency-text-field>
                                                </v-col>
                                                <v-col md="1" cols="12">
                                                    <v-btn @click="addProcurementCost(newProcurementCost)" :disabled="!canAddProcurementCost" color="success">
                                                        legg til
                                                        <v-icon right>mdi-plus-thick</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-container>

                                        <v-data-table :items="procurementsCost" :headers="procurementCostHeaders" disable-pagination hide-default-footer :mobile-breakpoint="0">
                                            <template v-slot:item.description="{item}">
                                                <span>{{item.description}}</span>
                                                <v-btn @click.stop="removeProcurementCost(item)" icon color="red">
                                                    <v-icon>mdi-delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <template v-slot:item.cost="{item}">
                                                {{formatAsCurrency(item.cost)}}
                                            </template>
                                            <template v-slot:body.append>
                                                <tr>
                                                    <th><span class="float-right">Sum innkjøpte kostnader</span></th>
                                                    <th><span class="font-weight-bold float-right">{{ formatAsCurrency(procurementsCost? procurementsCost.reduce((acc, cur) => { return acc + Number(cur.cost); }, 0) : 0)}}</span></th>
                                                </tr>
                                            </template>
                                        </v-data-table>

                                        <br>

                                        <span class="font-weight-bold">Registrer egeninnsats i form av timer (timer verdsettes til kr. {{app.hourlyRate}} pr. time)</span>
                                        <v-container>
                                            <v-row>
                                                <v-col md="8" cols="12">
                                                    <v-text-field v-model="newProcurementHours.description" @keyup.enter="() => { if(canAddProcurementHours) addProcurementHours(newProcurementHours)}" label="Beskrivelse av oppgaven" filled></v-text-field>
                                                </v-col>
                                                <v-col md="3" cols="12">
                                                    <v-text-field v-model="newProcurementHours.hours" @keyup.enter="() => { if(canAddProcurementHours) addProcurementHours(newProcurementHours)}" label="Timer" reverse filled :rules="[rules.inputIsNumber, rules.noDecimalMark, rules.noDecimal]">
                                                        <template v-slot:append>
                                                            <span class="ma-0">t</span>
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col md="1" cols="12">
                                                    <v-btn @click="addProcurementHours(newProcurementHours)" :disabled="!canAddProcurementHours" color="success">
                                                        legg til
                                                        <v-icon right>mdi-plus-thick</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                        <v-data-table :items="procurementsHours" :headers="procurementHoursHeaders" disable-pagination hide-default-footer :mobile-breakpoint="0">
                                            <template v-slot:item.description="{item}">
                                                <span>{{item.description}}</span>
                                                <v-btn @click.stop="removeProcurementHours(item)" icon color="red">
                                                    <v-icon>mdi-delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <template v-slot:body.append>
                                                <tr>
                                                    <th><span class="float-right">Sum timer</span></th>
                                                    <th><span class="font-weight-bold float-right">{{procurementsHours ? procurementsHours.reduce((acc, cur) => { return acc + Number(cur.hours); }, 0) : 0}}</span></th>
                                                </tr>
                                                <tr>
                                                    <th><span class="float-right">Sum verdi egeninnsats (kr)</span></th>
                                                    <th><span class="font-weight-bold float-right">{{ formatAsCurrency(procurementsHours ? procurementsHours.reduce((acc, cur) => { return acc + Number(cur.hours)*app.hourlyRate; }, 0) : 0)}}</span></th>
                                                </tr>
                                            </template>
                                        </v-data-table>

                                        <br>

                                        <v-container>
                                            <v-row class="grey lighten-2">
                                                <v-col cols="11">
                                                    <span>Totalsum for kostnader og egeninnsats i prosjektet</span>
                                                </v-col>
                                                <v-col cols="1">
                                                    <span class="float-right">{{formatAsCurrency((procurementsCost ? procurementsCost.reduce((acc, cur) => { return acc + Number(cur.cost); }, 0) : 0) + (procurementsHours ? procurementsHours.reduce((acc, cur) => { return acc + Number(cur.hours)*app.hourlyRate; }, 0) : 0))}}</span>
                                                </v-col>
                                            </v-row>
                                        </v-container>

                                        <br>

                                        <v-switch v-model="app.multiyear" label="Er dette et prosjekt over flere år?"></v-switch>

                                        <!-- <v-radio-group v-model="app.multiyear" row label="Er dette et prosjekt over flere år?">
                                            <v-radio label="Ja" :value="1"></v-radio>
                                            <v-radio label="Nei" :value="0"></v-radio>
                                        </v-radio-group> -->

                                        <v-expand-transition>
                                            <div v-if="app.multiyear" class="transition-fast-in-fast-out" style="width: 500px;">
                                                <!-- <v-text-field v-model="application.expenses.yearCount" label="Hvor mange år går prosjektet over"></v-text-field> -->
                                                <span class="font-weight-bold">Angi fordeling av kostnadene per år</span>
                                                <v-btn @click="addProcurementSplit" icon color="green">
                                                    <v-icon>mdi-plus-circle</v-icon>
                                                </v-btn>
                                                <v-btn @click="removeProcurementSplit" icon color="red">
                                                    <v-icon>mdi-minus-circle</v-icon>
                                                </v-btn>
                                                <v-data-table :items="app.procurementSplits" :headers="procurementSplitHeaders" hide-default-footer disable-pagination :mobile-breakpoint="0">
                                                    <template v-slot:item.percentage="{item}">
                                                        <v-text-field v-model="item.percentage" :rules="[rules.inputIsNumber, rules.noDecimalMark, v => rules.between(v,0,100)]" append-icon="mdi-percent"></v-text-field>
                                                    </template>
                                                    <template v-slot:body.append>
                                                        <tr>
                                                            <th><span>Sum prosent</span></th>
                                                            <th><span class="font-weight-bold">{{app.procurementSplits ? app.procurementSplits.reduce((acc, cur) => { return acc + Number(cur.percentage); }, 0) : 0}}%</span></th>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                            </div>
                                        </v-expand-transition>

                                    </v-form>
                                </v-card-text>
                            </v-card>

                        </v-stepper-content>
                        <v-stepper-content step="5">
                            <v-card>
                                <v-card-title>Finansieringsplan</v-card-title>
                                <v-card-text>
                                    <v-form>
                                        <v-row class="grey lighten-3">
                                            <v-col md="10">
                                                <span class="subtitle-1 font-weight-bold">Totalsum for egeninnsats i prosjektet</span>
                                            </v-col>
                                            <v-col md="2">
                                                <span class="float-right subtitle-1 font-weight-bold">{{formatAsCurrency(totalProcurementHours)}}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row class="grey lighten-3">
                                            <v-col md="10">
                                                <span class="subtitle-1 font-weight-bold">Totalsum for kostnader i prosjektet (uten egeninnsats)</span>
                                            </v-col>
                                            <v-col md="2">
                                                <span class="float-right subtitle-1 font-weight-bold">{{formatAsCurrency(totalProcurementExpenses - totalProcurementHours)}}</span>
                                            </v-col>
                                        </v-row>

                                        <v-radio-group v-model="app.totalFunding" label="Søker dere om totalfinansiering fra Sparebankstiftelsen Telemark - Holla og Lunde" class="subtitle-1 font-weight-bold" row>
                                            <v-radio label="Ja" :value="1" class="body-1"></v-radio>
                                            <v-radio label="Nei" :value="0" class="body-1"></v-radio>
                                        </v-radio-group>

                                        <v-expand-transition>
                                            <div v-if="!app.totalFunding">
                                                <div>
                                                    <span class="subtitle-1 font-weight-bold">Oppgi hvordan finansieringen fordeles mellom egenkapital og stiftelsen</span>
                                                    <!-- <v-container> -->
                                                    <v-row no-gutters>
                                                        <v-col md="10" cols="12" align-self="center">
                                                            <span>Angi egenkapital dere går inn med i prosjektet</span>
                                                        </v-col>
                                                        <v-col md="2" cols="12">
                                                            <!-- <v-text-field v-model="app.ownFunding" label="Beløp" filled reverse :rules="[rules.inputIsNumber, rules.noDecimalMark, rules.noDecimal]"></v-text-field> -->
                                                            <!-- <v-text-field v-model="ownFunding" label="Beløp" filled reverse :rules="[rules.inputIsNumber, rules.noDecimalMark, rules.noDecimal]"></v-text-field> -->
                                                            <currency-text-field v-model="app.ownFunding" label="Beløp" filled reverse :rules="[rules.inputIsNumber, rules.noDecimalMark, rules.noDecimal]"></currency-text-field>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row no-gutters>
                                                        <v-col md="10" cols="12" align-self="center">
                                                            <span>Søknadsbeløp fra Sparebankstiftelsen Telemark - Holla og Lunde</span>
                                                        </v-col>
                                                        <v-col md="2" cols="12">
                                                            <!-- <v-text-field v-model="app.foundationFunding" label="Beløp" filled reverse :rules="[rules.inputIsNumber, rules.noDecimalMark, rules.noDecimal]"></v-text-field> -->
                                                            <currency-text-field v-model="app.foundationFunding" label="Beløp" filled reverse :rules="[rules.inputIsNumber, rules.noDecimalMark, rules.noDecimal]"></currency-text-field>
                                                        </v-col>
                                                    </v-row>
                                                    <!-- </v-container> -->
                                                </div>
                                                <br>
                                                <br>
                                                <span class="body-1 font-weight-bold">Navn på andre finansieringspartnere</span>

                                                <v-row>
                                                    <v-col md="8" cols="12">
                                                        <v-text-field v-model="newExternalFunding.description" @keyup.enter="() => { if(canAddExternalFunding) addExternalFunding(newExternalFunding)}" label="Navn på annen finansieringspartner" filled></v-text-field>
                                                    </v-col>
                                                    <v-col md="3" cols="12">
                                                        <!-- <v-text-field v-model="newExternalFunding.amount" label="Beløp" filled reverse :rules="[rules.inputIsNumber, rules.noDecimalMark, rules.noDecimal]">
                                                            <template v-slot:append>
                                                                <span class="ma-0">kr</span>
                                                            </template>
                                                        </v-text-field> -->
                                                        <currency-text-field v-model="newExternalFunding.amount" @keyup.enter="() => { if(canAddExternalFunding) addExternalFunding(newExternalFunding)}" label="Beløp" filled reverse :rules="[rules.inputIsNumber, rules.noDecimalMark, rules.noDecimal]">
                                                            <template v-slot:append>
                                                                <span class="ma-0">kr</span>
                                                            </template>
                                                        </currency-text-field>
                                                    </v-col>
                                                    <v-col md="1" cols="12">
                                                        <v-btn @click="addExternalFunding(newExternalFunding)" :disabled="!canAddExternalFunding" color="success">
                                                            legg til
                                                            <v-icon right>mdi-plus-thick</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>

                                                <v-data-table :items="app.fundings" :headers="fundingHeaders" class="grey lighten-4" hide-default-footer disable-pagination :mobile-breakpoint="0">
                                                    <template v-slot:item.description="{item}">
                                                        <span>{{item.description}}</span>
                                                        <v-btn @click.stop="removeExternalFunding(item)" icon color="red">
                                                            <v-icon>mdi-delete</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <template v-slot:item.amount="{item}">
                                                        <span>{{formatAsCurrency(item.amount)}}</span>
                                                    </template>
                                                    <template v-slot:body.append>
                                                        <tr>
                                                            <th><span class="float-right">Sum finansiering</span></th>
                                                            <th><span class="font-weight-bold float-right">{{formatAsCurrency(app.fundings ? app.fundings.reduce((acc, cur) => { return acc + Number(cur.amount); }, 0) : 0)}}</span></th>
                                                        </tr>
                                                    </template>
                                                    <template v-slot:no-data>
                                                        <div>Ingen finansieringspartnere</div>
                                                    </template>
                                                </v-data-table>
                                            </div>
                                        </v-expand-transition>

                                        <v-container>
                                            <v-row>
                                                <v-col md="10">
                                                    <span><v-icon>mdi-alert-decagram</v-icon> Kontrollsjekk - finansiering og kostnadsbudsjett må gå i null</span>
                                                </v-col>
                                                <v-col md="2">
                                                    <span class="float-right">{{applicationCost - applicationFunding}}</span>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col md="10" class="my-auto">
                                                    <span>Kontonummer - for utbetalinger</span>
                                                </v-col>
                                                <v-col md="2">
                                                    <v-text-field v-model="app.account" ref="account" label="kontonummer" dense filled :rules="[v => !!v || 'Påkrevd', accountRules.format]"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-form>
                                </v-card-text>
                            </v-card>
                        </v-stepper-content>
                        <v-stepper-content step="6">
                            <v-card>
                                <v-card-title>Kort beskrivelse av prosjektet</v-card-title>
                                <v-card-text>
                                    <span class="body-1">Gi en kort beskrivelse av prosjektet</span>
                                    <v-textarea v-model="app.description" outlined placeholder="Skriv her" :hint="`${this.app.maximumDescriptionLength - (this.app.description ? this.app.description.length:0)} tegn igjen.`" :rules="[v => (!!v ? v.length <= this.app.maximumDescriptionLength : true) || `${this.app.description.length - this.app.maximumDescriptionLength} tegn for mange.`]"></v-textarea>
                                </v-card-text>
                            </v-card>
                        </v-stepper-content>

                        <v-row justify="end" class="mb-2 mr-6">

                            <!-- <v-btn :disabled="sessionStep == 1" @click="gotoStart" color="primary" class="ma-2">
                                <v-icon left>mdi-page-first</v-icon>
                                Start
                            </v-btn> -->
                            <v-btn :disabled="sessionStep == 1" @click="gotoPrevious" color="primary" class="ma-2">
                                <v-icon left>mdi-chevron-left</v-icon>
                                Forrige
                            </v-btn>
                            <v-btn @click="gotoPause" color="warning" class="ma-2">
                                <v-icon left>mdi-content-save</v-icon>
                                Lagre
                            </v-btn>
                            <v-btn :disabled="!canGotoNext()" @click="gotoNext" color="primary" class="ma-2">
                                Neste
                                <v-icon right>mdi-chevron-right</v-icon>
                            </v-btn>
                            <!-- <v-btn :disabled="sessionStep >= app.step" @click="gotoLatest" color="primary" class="ma-2">
                                Siste
                                <v-icon right>mdi-page-last</v-icon>
                            </v-btn> -->

                            <v-btn :disabled="!canSendIn()" @click="gotoSendIn" color="success" class="ma-2">
                                Send inn
                                <v-icon right>mdi-send</v-icon>
                            </v-btn>

                        </v-row>
                    </v-stepper-items>
                </v-stepper>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { ApplicationStatus } from "../utilities/enums";
import moment from "moment";
import * as rules from "../utilities/rules";
import { formatAsCurrency} from "../utilities/utils";
import { colors as appColors } from "../utilities/colors";

export default {
    props: ["id"],
    data: () => ({
        appColors,
        sessionStep: null,
        app: {
            step: 1
        },
        accountRules: {
            format: function(account) {
                let regex = /^\d{11}$/;
                if(regex.test(account)){
                    return true;
                }

                return "Riktig format er et 11 sifret tall";
            },
        },
        newProcurementCost: {
            id: null,
            description: null,
            type: 0,
            cost: null,
            hours: null,
            application_id: null
        },
        newProcurementHours: {
            id: null,
            description: null,
            type: 10,
            cost: null,
            hours: null,
            application_id: null
        },
        newExternalFunding: {
            id: null,
            description: null,
            amount: null,
            application_id: null
        },
        procurementCostHeaders: [
            { text: "Beskrivelse", value: "description" },
            { text: "Beløp", value: "cost", align: "end", width: "15%" }
        ],
        procurementHoursHeaders: [
            { text: "Beskrivelse", value: "description" },
            { text: "Timer", value: "hours", align: "end", width: "15%" }
        ],
        procurementSplitHeaders: [
            { text: "År", value: "year" },
            { text: "Prosent pr. år", value: "percentage", width: "50%" }
        ],
        fundingHeaders: [
            { text: "Beskrivelse", value: "description" },
            { text: "Beløp", value: "amount", align: "end", width: "15%" }
        ],
        rules,
        formatAsCurrency,
    }),
    computed: {
        ownFunding: {
            get: function(){
                return this.formatAsCurrency(this.app.ownFunding)
            },
            set: function(newValue, oldValue){
                if(newValue === "-" || newValue === "+"){
                    this.app.ownFunding = newValue;
                    return
                }
                // value = value.replace(/[^0-9-+]/gm, "");

                if(isNaN(Number(newValue))){
                    newValue = oldValue
                }

                this.app.ownFunding = Number(newValue.toString().replace(/\s/gm,""))
            }
        },
        applicationChoicesPurpose() {
            if (!this.app.applicationChoices) {
                return [];
            }
            return this.app.applicationChoices.filter(ac => ac.type == 0);
        },
        applicationChoicesArea() {
            if (!this.app.applicationChoices) {
                return [];
            }
            return this.app.applicationChoices.filter(ac => ac.type == 10);
        },
        applicationChoicesAgeGroup() {
            if (!this.app.applicationChoices) {
                return [];
            }
            return this.app.applicationChoices.filter(ac => ac.type == 100);
        },
        procurementsCost() {
            if (!this.app.procurements) {
                return [];
            }
            return this.app.procurements.filter(p => p.type == 0);
        },
        procurementsHours() {
            if (!this.app.procurements) {
                return [];
            }
            return this.app.procurements.filter(p => p.type == 10);
        },
        totalProcurementHours() {
            return (this.procurementsHours ? this.procurementsHours.reduce((acc, cur) => { return acc + Number(cur.hours)*this.app.hourlyRate; }, 0) : 0);
        },
        totalProcurementExpenses() {
            return (
                (this.procurementsCost
                    ? this.procurementsCost.reduce((acc, cur) => {
                          return acc + Number(cur.cost);
                      }, 0)
                    : 0) +
                (this.procurementsHours
                    ? this.procurementsHours.reduce((acc, cur) => {
                          return acc + Number(cur.hours) * this.app.hourlyRate;
                      }, 0)
                    : 0)
            );
        },

        canAddProcurementCost() {
            return this.newProcurementCost.description && this.newProcurementCost.description.trim() && this.newProcurementCost.cost && this.newProcurementCost.cost.toString().trim() && !this.procurementsCost.some(p => p.description == this.newProcurementCost.description.trim());
        },
        canAddProcurementHours() {
            return this.newProcurementHours.description && this.newProcurementHours.description.trim() && this.newProcurementHours.hours && this.newProcurementHours.hours.toString().trim() && !this.procurementsHours.some(p => p.description == this.newProcurementHours.description.trim());
        },
        canAddExternalFunding() {
            return this.newExternalFunding.description && this.newExternalFunding.description.trim() && this.newExternalFunding.amount && this.newExternalFunding.amount.toString().trim() && !this.app.fundings.some(p => p.description == this.newExternalFunding.description.trim());
        },
        applicationCost() {
            return (
                Number(
                    this.procurementsCost
                        ? this.procurementsCost.reduce((acc, cur) => {
                              return acc + Number(cur.cost);
                          }, 0)
                        : 0
                )
                // +
                // Number(
                //     this.procurementsHours
                //         ? this.procurementsHours.reduce((acc, cur) => {
                //               return acc + Number(cur.hours) * this.app.hourlyRate;
                //           }, 0)
                //         : 0
                // )
            );
        },
        applicationFunding() {
            let ownFunding = Number(this.app.ownFunding);
            let foundationFunding = Number(this.app.foundationFunding);
            let externalFunding = this.app.fundings
                ? Number(
                      this.app.fundings.reduce((acc, cur) => {
                          return acc + Number(cur.amount);
                      }, 0)
                  )
                : 0;

            return ownFunding + foundationFunding + externalFunding;
        }
    },
    methods: {
        selectArea(area) {
            area.selected = true;
            this.applicationChoicesArea.forEach(a => {
                if (a.name != area.name) {
                    a.selected = false;
                }
            });
        },
        selectAgeGroup(ageGroup) {
            ageGroup.selected = true;
            this.applicationChoicesAgeGroup.forEach(a => {
                if (a.name != ageGroup.name) {
                    a.selected = false;
                }
            });
        },
        addProcurementCost(procurementCost) {
            let _procurementCost = {};
            Object.assign(_procurementCost, procurementCost);
            this.app.procurements.push(_procurementCost);

            this.newProcurementCost.description = undefined;
            this.newProcurementCost.cost = undefined;

            // this.application.expenses.procurement.description = null;
            // this.application.expenses.procurement.amount = null;
        },
        removeProcurementCost(procurementHours) {
            let index = this.app.procurements.findIndex(p => p.description == procurementHours.description && p.type == 0);
            if (index > -1) {
                this.app.procurements.splice(index, 1);
            }
        },
        addProcurementHours(procurementHours) {
            let _procurementHours = {};
            Object.assign(_procurementHours, procurementHours);
            this.app.procurements.push(_procurementHours);

            this.newProcurementHours.description = undefined;
            this.newProcurementHours.hours = undefined;

            // this.application.expenses.procurement.description = null;
            // this.application.expenses.procurement.amount = null;
        },
        removeProcurementHours(procurementHours) {
            let index = this.app.procurements.findIndex(p => p.description == procurementHours.description && p.type == 10);
            if (index > -1) {
                this.app.procurements.splice(index, 1);
            }
        },
        addProcurementSplit() {
            let _addProcurementSplit = () => {
                    this.app.procurementSplits.push({
                    id: null,
                    year: this.app.procurementSplits.length + 1,
                    percentage: 0,
                    application_id: null
                });
            }

            if(this.app.procurementSplits.length == 0){
                _addProcurementSplit();
                _addProcurementSplit();
            }
            else{
                _addProcurementSplit();
            }
        },
        removeProcurementSplit() {
            let _removeProcurementSplit = () => {
                this.app.procurementSplits.pop();
            }

            if(this.app.procurementSplits.length == 2){
                _removeProcurementSplit();
                _removeProcurementSplit();
            }
            else{
                _removeProcurementSplit();
            }
        },
        addExternalFunding(externalFunding) {
            let _externalFunding = {};
            Object.assign(_externalFunding, externalFunding);
            this.app.fundings.push(_externalFunding);

            this.newExternalFunding = {
                id: null,
                description: null,
                amount: 0,
                application_id: null
            };

            // this.application.financing.contribution.description = "";
            // this.application.financing.contribution.amount = "";
        },
        removeExternalFunding(ownFunding) {
            let index = this.app.fundings.findIndex(p => p.description == ownFunding.description);
            if (index > -1) {
                this.app.fundings.splice(index, 1);
            }
        },
        // convertCommaStringToDotNumber(commaString) {
        //     let dotString = commaString.replace(",", ".");
        //     let dotNumber = Number(dotString);

        //     // TODO check IsNaN
        //     return dotNumber;
        // },
        // convertDotNumberToCommaString(dotNumber) {
        //     let dotString = dotNumber.toString();

        //     let fractional = "00";
        //     let fractionalRegex = /^\d+\.(\d{0,2})?$/;
        //     let result = fractionalRegex.exec(dotString);
        //     if (result) {
        //         fractional = result[1];
        //         fractional = fractional.padEnd(2, "0");
        //     }

        //     return dotString
        //         .replace(/\.(\d{0,2})?$/, `.${fractional}`)
        //         .replace(".", ",");
        // },

        gotoStart() {
            if (this.sessionStep > 1) {
                this.saveExisting();
            }

            this.sessionStep = 1;
        },
        gotoPrevious() {
            if (this.sessionStep > 1) {
                this.saveExisting();
            }

            this.sessionStep--;
        },
        canGotoNext() {
            if (this.sessionStep == 1) {
                return this.app.name && this.app.name.length > 0 && this.applicationChoicesPurpose && this.applicationChoicesPurpose.some(purpose => purpose.selected);
            }

            if (this.sessionStep == 2) {
                return this.applicationChoicesArea && this.applicationChoicesArea.some(area => area.selected);
            }

            if (this.sessionStep == 3) {
                return this.applicationChoicesAgeGroup && this.applicationChoicesAgeGroup.some(area => area.selected);
            }

            if (this.sessionStep == 4) {
                let canNext = this.procurementsCost.length > 0 || this.procurementsHours.length > 0;
                if (!canNext) return false;

                if (this.app.multiyear) {
                    let total = this.app.procurementSplits.reduce((acc, cur) => {
                        return acc + Number(cur.percentage);
                    }, 0);
                    canNext = total === 100;
                } else {
                    canNext = this.app.procurementSplits.length == 0;
                }

                return canNext;
            }

            if (this.sessionStep == 5) {
                if (this.app.totalFunding == 1 || this.app.totalFunding == true) {
                    return true;
                }

                // if(this.$refs.account && !this.$refs.account.validate()){
                //     return false;
                // }

                let rule = this.accountRules.format(this.app.account)

                if(!this.app.account || rule !== true){
                    return false;
                }

                return this.applicationCost - this.applicationFunding === 0;
            }

            if (this.sessionStep == 6) {
                return false;
            }

            return true;
        },
        gotoNext() {
            this.sessionStep++;
            if (this.sessionStep > this.app.step) {
                this.app.step++;
            }

            if (this.id == 0) {
                this.saveNew();
            } else {
                this.saveExisting();
            }
        },
        gotoLatest() {
            if (this.sessionStep < this.app.step) {
                this.sessionStep = this.app.step;
            }

            this.saveExisting();
        },
        gotoPause() {
            if (this.id == 0) {
                this.saveNew();
            } else {
                this.saveExisting();
            }
        },
        canSendIn() {
            if (this.sessionStep == 6) {
                let result = this.app.description && this.app.description.length > 0;
                return result;
            }
            return false;
        },
        async gotoSendIn() {
            // try {
            let status = {
                type: ApplicationStatus.ADMITTED,
                createdAt: moment().unix(),
                createdBy_id: this.$store.getters.user.id
            };
            this.app.statuses.push(status);

            await this.saveExisting();
            this.$router.push({ name: "applications" });
            // } catch (error) {
            //     console.error(error);
            // }
        },
        async saveNew() {
            if (this.id == 0) {
                try {
                    this.app = await this.$store.dispatch("createApplication", this.app);

                    this.$router.push({ path: `/application/${this.app.id}` });

                    this.$store.commit("snackbar", {
                        text: "Lagret.",
                        color: "success"
                    });
                } catch {
                    // console.error(error);
                    this.$store.commit("snackbar", {
                        text: "Lagring feilet.",
                        color: "error"
                    });
                }
            }
        },
        async saveExisting() {
            if (this.id > 0) {
                try {
                    this.app = await this.$store.dispatch("updateApplication", this.app);

                    this.$store.commit("snackbar", {
                        text: "Lagret.",
                        color: "success"
                    });
                } catch {
                    // console.error(error);
                    this.$store.commit("snackbar", {
                        text: "Lagring feilet.",
                        color: "error"
                    });
                }
            }
        },

        // async current() {
        //     try {
        //         this.sessionStep = this.app.step;

        //         if (!this.app.id || this.app.id === 0 || this.app.id === "0") {
        //             this.app = await this.$store.dispatch("createApplication", this.app);
        //         } else {
        //             this.app = await this.$store.dispatch("updateApplication", this.app);
        //         }
        //     } catch {
        //         // console.error(err);
        //         this.$store.commit("snackbar", {
        //             text: "Søknad ikke lagret.",
        //             color: "error"
        //         });
        //     }
        // },
        // async pause() {
        //     try {
        //         if (!this.app.id || this.app.id === 0 || this.app.id === "0") {
        //             this.app = await this.$store.dispatch("createApplication", this.app);
        //         } else {
        //             this.app = await this.$store.dispatch("updateApplication", this.app);
        //         }

        //         this.$router.push({ name: "applications" });
        //     } catch {
        //         // console.error(err);
        //         this.$store.commit("snackbar", {
        //             text: "Søknad ikke lagret.",
        //             color: "error"
        //         });
        //     }
        // },
        // async next() {
        //     // console.log("next");
        //     if (this.sessionStep < 6) {
        //         try {
        //             let _sessionStep = this.sessionStep + 1;

        //             if (_sessionStep > this.app.step) {
        //                 this.app.step = _sessionStep;
        //             }

        //             if (!this.app.id || this.app.id === 0 || this.app.id === "0") {
        //                 this.app = await this.$store.dispatch("createApplication", this.app);
        //             } else {
        //                 this.app = await this.$store.dispatch("updateApplication", this.app);
        //             }

        //             this.sessionStep = _sessionStep;
        //         } catch {
        //             // console.error(err);
        //             this.$store.commit("snackbar", {
        //                 text: "Søknad ikke lagret.",
        //                 color: "error"
        //             });
        //         }
        //     } else {
        //         // application is done
        //         try {
        //             // this.app.status = ApplicationStatus.ADMITTED;
        //             this.app.statuses.push({
        //                 type: ApplicationStatus.ADMITTED,
        //                 createdAt: moment().unix(),
        //                 createdBy_id: this.$store.getters.user.id
        //             });
        //             await this.$store.dispatch("updateApplication", this.app);
        //             this.$router.push({ name: "applications" });
        //         } catch {
        //             // this.app.status = ApplicationStatus.CREATED;
        //             this.app.statuses.pop();
        //             // console.error(err);
        //             this.$store.commit("snackbar", {
        //                 text: "Søknad ikke lagret.",
        //                 color: "error"
        //             });
        //         }
        //     }
        // },
        // previous() {
        //     this.sessionStep == 1 ? (this.sessionStep = 1) : this.sessionStep--;
        // },
        async fetchNewApplication() {
            try {
                this.sessionStep = 1;
                this.app = await this.$store.dispatch("getEmptyApplication");
            } catch {
                // console.error(err);
                this.$store.commit("snackbar", {
                    text: "Hent av ny søknad mislukket.",
                    color: "error"
                });
                this.$router.push({ name: "applications" });
            }
        },
        async fetchOldApplication(applicationId) {
            try {
                let application = await this.$store.dispatch("getApplication", { applicationId });
                this.$set(this, "app", application);
                this.sessionStep = this.app.step;
            } catch {
                // console.error(err);
                this.$store.commit("snackbar", {
                    text: "Hent av søknad mislukket.",
                    color: "error"
                });
                this.$router.push({ name: "applications" });
            }
        }
    },
    watch: {
        "$route.params": {
            handler: async function() {
                // console.log(val);
                if (this.id == 0) {
                    this.fetchNewApplication();
                } else {
                    this.fetchOldApplication(this.id);
                }
            }
            // immediate: true
        },
        "app.multiyear": {
            handler: function(multiyear) {
                if (!multiyear) {
                    this.app.procurementSplits.splice(0);
                }
            }
        },
        "app.totalFunding": {
            handler: function(totalFunding) {
                if (totalFunding) {
                    this.app.ownFunding = 0;
                    this.app.foundationFunding = this.totalProcurementExpenses - this.totalProcurementHours;
                    this.app.fundings.splice(0);
                }
                // else {
                // this.app.ownFunding = 0;
                // this.app.foundationFunding = 0;
                // }
            }
        }
    },
    async mounted() {
        // console.log("mounted");
        if (this.id == 0) {
            this.fetchNewApplication();
        } else {
            this.fetchOldApplication(this.id);
        }
    }
};
</script>

<style lang="scss" scoped>
</style>